module.exports = __webpack_public_path__ + "img/buoy.9b09f0f3.svg";